module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-02.0fb409f0.png";